import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paperless-agreement',
  templateUrl: './paperless-agreement.component.html',
  styleUrls: ['./paperless-agreement.component.scss']
})
export class PaperlessAgreementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
